module.exports = __webpack_public_path__ + "img/MysteryOfTheCongo_EGM.db6ca38e.png";